/*
    Description: class for search overlay when user clicks search icon 
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/

// import utility
import Utility from "../inc/utility";

// extend utility class
class Search extends Utility{

    // constructor
    constructor({

        // add selectors
        searchClass = "searching",
        searchIconClass = "--js-search",
        searchCloseBttnClass = "searching__close",
        searchFormClass = "searching__wrapper__form",
        searchFormInputClass = "searching__wrapper__form__term__input",
        clearButtonClass = "searching__wrapper__form__term__clear",
        resultsClass = "searching__wrapper__results",
        loadingClass = "--js-searching",
        hideClass = "--js-search-hide",
        noscroll = "--js-noscroll",
        
    } = {}){
        
        // extend class
        super();

        // body
        this.body = (document.getElementsByTagName("body"))? document.getElementsByTagName("body")[0] : null;

        // search wrapper
        this.wrapper = document.querySelector(`.${searchClass}`);
        
        // get icon
        this.icon = document.querySelector(`.${searchIconClass}`);

        // form
        this.form = document.querySelector(`.${searchFormClass}`);

        // input
        this.input = document.querySelector(`.${searchFormInputClass}`);

        // close button
        this.close = document.querySelector(`.${searchCloseBttnClass}`);

        // clear button
        this.clear = document.querySelector(`.${clearButtonClass}`);

        // result area
        this.results = document.querySelector(`.${resultsClass}`);

        // add animation
        this.loading = loadingClass;

        // no scroll class
        this.noscroll = noscroll;

        // hide class
        this.hide = hideClass;

        // stop api request/call
        this.stop = false;

        // how many characters before form has been submitted
        this.limit = 3;

        // setTimeOut variable holder 
        this.timer = null;

        // timer delay in milliseconds
        this.delay = 888;

        // run init method
        this.init()

    }

    // init method
    init(){
        
        // add eventListener: icon
        if(this.icon) this.icon.addEventListener("click", this.searchOverlay.bind(this));
        if(this.icon) this.icon.addEventListener("keydown", this.searchEnterOpen.bind(this));

        // add eventListen: close button
        if(this.close) this.close.addEventListener("click", this.searchOverlayClose.bind(this));

        // add eventListen: clear button
        if(this.clear) this.clear.addEventListener("click", this.searchOverlayClear.bind(this));
        if(this.clear) this.clear.addEventListener("keydown", this.searchOverlayClearEnter.bind(this));

        // add eventListener: term input 
        if(this.input) this.input.addEventListener("input", this.inputUpdate.bind(this));

        // add eventListner: form submit 
        if(this.form) this.form.addEventListener("submit", this.formSubmit.bind(this));

        // trap focus
        if(this.wrapper && (typeof this.trapFocus === "function")) this.trapFocus(this.wrapper);

        // enter press check on element
        if(this.wrapper && (typeof this.pressEnterClose === "function")) this.pressEnterClose(this.close, this.searchOverlayClose.bind(this));

    }

    // input field has been updated 
    inputUpdate(e){

        // prevent default
        e.preventDefault();

        // get input value
        const inputValue = e.target.value;

        // set self to this
        const self = this;

        // reset timer
        clearTimeout(self.timer);

        // set timer
        self.timer = setTimeout(function(){

            // reset stop
            self.stop = false;

            // submit form if we are over limit
            if(inputValue.length >= self.limit) self.formSubmit(e);

        // delay time
        }, self.delay);

        // check input is empty
        if(self.input.value.length <= 0){

            // reset results     
            self.results.innerHTML = "";

            // hide clear bttn
            this.showClearButton(false);

        // input has value
        }else{

            // show clear bttn
            this.showClearButton();
        
        }

    }

    // display search overlay
    searchOverlay(e){

        // prevent default
        e.preventDefault();
        
        // end case
        if(!this.wrapper) return;

        // remove hide class
        this.wrapper.classList.remove(this.hide);

        // update attributes
        this.wrapper.setAttribute("aria-hidden", false);
        this.wrapper.setAttribute("tabindex", 0);

        // add no scroll to body
        if(this.body && this.body[0]) this.body.classList.add(this.noscroll);

        // focus on close button
        this.close.focus();

        // return
        return;

    }

    // display search when user hits enter
    searchEnterOpen(e){

        // get current key
        const thisKey = e.key.toLowerCase() || e.keyCode,

        // get active element
        active = document.activeElement;

        // check if focus is on search icon and user hits enter 
        if((active == this.icon) && (thisKey == "enter" || thisKey == 13)){
            
            // open overlay
            this.searchOverlay(e);

        }

    }

    // close button
    searchOverlayClose(e){

        // prevent default
        e.preventDefault();
        
        // end case
        if(!this.wrapper) return;

        // remove hide class
        this.wrapper.classList.add(this.hide);

        // update attributes
        this.wrapper.setAttribute("aria-hidden", true);
        this.wrapper.setAttribute("tabindex", -1);

        // remove no scroll to body
        if(this.body) this.body.classList.remove(this.noscroll);

        // reset overlay
        this.searchOverlayClear(e);

        // focus on icon button
        if(this.icon) this.icon.focus();

        // return
        return;

    }

    // clear button
    searchOverlayClear(e){

        // prevent default
        e.preventDefault();
        
        // end case
        if(!this.wrapper) return;

        // clear input
        if(this.input) this.input.value = "";

        // remove loading icon
        if(this.input) this.input.parentNode.classList.remove(this.loading);

        // hide clear bttn
        this.showClearButton(false);

        // reset results
        this.searchResults("");

        // focus on input
        if(this.input) this.input.focus();

        // stop api results
        this.stop = true;

        // return
        return;

    }

    // clear entered text when user hits enter
    searchOverlayClearEnter(e){

        // get current key
        const thisKey = e.key.toLowerCase() || e.keyCode,

        // get active element
        active = document.activeElement;

        // check if focus is on search icon and user hits enter 
        if((active == this.clear) && (thisKey == "enter" || thisKey == 13)){
            
            // open overlay
            this.searchOverlayClear(e);

        }

    }
    
    // form submit
    formSubmit(e = null){

        // prevent default
        if(e !== null || !this.input) e.preventDefault();
        
        // set self to this
        const self = this;

        // add animation
        if(!self.stop) self.input.parentNode.classList.add(this.loading);

        // make sure input has value
        if(self.input.value.length < this.limit){

            // remove animation
            self.input.parentNode.classList.remove(self.loading);

            // reset results     
            self.results.innerHTML = "";

            // reset timer
            clearTimeout(self.timer);

            //return
            return;

        }

        // ajax call
        self.ajax({
            
            // send data
            data:new FormData(self.form),
            
            // url
            action:"search",
        
        // promise results 
        }).then((results) => {

            // remove animation
            self.input.parentNode.classList.remove(self.loading);

            // get results
            if(!self.stop) self.searchResults(results);

            // reset stop
            self.stop = false;    

        // catch error
        }).catch((err) => {
            
            // remove animation
            self.input.parentNode.classList.remove(self.loading);

            // reset stop
            self.stop = false;

            // display error
            console.log(err);

        });
        
    }

    // output results
    searchResults(data = null){
        
        // make sure we have data 
        if(data == null && !this.results) return;

        // reset results
        this.results.innerHTML = "";

        // SUCCESS:check for success
        if(data && data.success){

            // create ul
            const ul = document.createElement("ul");

            // LOOP: thru data 
            for(const li in data.success){

                // create li
                const thisLI = document.createElement("li"),
                
                // create anchor link
                a = document.createElement("a"),

                // create span 
                span = document.createElement("span"),

                // create p
                p = document.createElement("p"),

                // tmp textarea to convert html enetities
                tmp = document.createElement("textarea"),

                // get post type
                parent = data.success[li]["parent"],

                // title
                title = data.success[li]["title"],
                
                // link
                link = data.success[li]["link"],
                
                // date
                date = data.success[li]["date"],

                // copy
                copy = data.success[li]["copy"];

                // add tabindex to li
                thisLI.setAttribute("tabindex", 0);

                // set parentCopy
                let parentCopy = parent;
                
                // update label for bike and walk arlington
                if(parentCopy === "bike" || parentCopy === "walk") parentCopy = `${parent}Arlington`;
                
                // remove dashes from label 
                if(parentCopy) parentCopy = parentCopy.replaceAll("-"," ");

                // add class and copy to anchor
                a.classList.add("searching__wrapper__results__link")
                a.innerHTML = (parent) ? `<span class='--js-type-${parent}'>${title}<span>` : `${title}`;
                
                // set link location
                a.setAttribute("href", link);

                // set title tag
                a.setAttribute("title", `Click this link to read more about '${title}'`);

                // set link target
                a.setAttribute("target", "_self");

                // add class and copy to date span
                span.classList.add("searching__wrapper__results__date");
                span.innerHTML = (parent && parentCopy) ? `${date} <span class='--js-type-${parent}'>[${parentCopy}]</span>` : `${date}`;

                // add class and copy to date span
                p.classList.add("searching__wrapper__results__copy");
        
                // convert html entities - hackey
                tmp.innerHTML = copy;
                p.textContent = tmp.value;

                // add DOM elements to li
                thisLI.appendChild(a);
                thisLI.appendChild(span);
                thisLI.appendChild(p);

                // add li to ul
                ul.appendChild(thisLI);

            }

            // append ul to results
            this.results.appendChild(ul);

            // focus on first result - disable since this creates UX issue - can still be tabbed for 508
            // if(ul.children) ul.children[0].focus();

        // FAIL
        }else{
            
            // make sure we have an error
            if(data.error){
                
                // create p tag
                const p = document.createElement("p");
                
                // add class
                p.classList.add("--error");

                // set tabindex
                p.setAttribute("tabindex", 0);

                // p text
                p.textContent = data.error;

                // add error msg to results
                this.results.appendChild(p);

                // focus on first result
                if(this.results.children) this.results.children[0].focus();                
                
            }

        }

    }

    // toggle clear bttn visibility
    showClearButton(state = true){

        // make sure we have clear bttn DOM element
        if(!this.clear) return;

        // SHOW button
        if(state){

            // add hide class
            this.clear.classList.remove(this.hide);

            // update attributes
            this.clear.setAttribute("aria-hidden", false);
            this.clear.setAttribute("tabindex", 0);

        // HIDE: button
        }else{

            // add hide class
            this.clear.classList.add(this.hide);

            // update attributes
            this.clear.setAttribute("aria-hidden", true);
            this.clear.setAttribute("tabindex", -1);
        
        }

    }

}

// export default
export default Search;